const GurukelasAdd ={
    listGuru:[],
    idKelas:null,
    idKelasParalel:null,
}

export default GurukelasAdd;